<template>
  <div :class="{ tile: pathstep.mode !== 'STile', stile: pathstep.mode === 'STile' }">
    <PinchInQue v-show="isShowPinchIn" :pinchInText="pinchInText" :pathstep="pathstep" :pinchInShowVoice="showQestionVoice" :choiceNum="choiceNum"
                :pinchInSound="pinchInSound" @pinchOut="recievePinchOut"  @pinchiInAudioPlay="audioPlay" @pinchInaudioPause="audioPause()"/>
    <PinchInActStore/>
    <!-- 問題表示欄 -->
    <div class="page-content">
      <div class="inner flexrow" :class="cssLayoutID">

        <div class="toparea-play pinch-toparea">
          <div class="flexstretch" v-show="showSelectAnswer">
            <template v-if="pathstep.mode === 'STile'">
              <!-- PCレイアウト -->
              <template v-if="isEnvironmentPc()">
                <div v-show="showChoice" class="item" v-bind:class="{disabled:choiceDisabled}" v-bind:id="'choice_list_1_' + index" v-for="(choiceItem, index) in choiceList" @click="clickAnswer(choiceItem.text, index, 1)" :key="index"
                     @touchstart="onTouchStart(getDispChoiceText(choiceItem.confuserIndex ,choiceItem.confuserItemIndex, choiceItem.text), 1, choiceItem.sound)"
                     @touchend="onTouchEnd()"
                     @touchmove="onTouchEnd()"
                     @mousedown="$emit('hintMouseDown', $event)" @mouseup="$emit('hintMouseUp', $event)"
                     @mousemove="$emit('hintMouseMove', $event)">
                  <button v-show="showPinchInBtn" class="icon-pinch-in" @click="clickPinchIn(getDispChoiceText(choiceItem.confuserIndex ,choiceItem.confuserItemIndex, choiceItem.text), 1, choiceItem.sound)"></button>
                  <div class="buttons">
                    <button class="icon-num1"></button>
                    <button class="icon-voice disabled" @click="choiceAudioPlay(choiceItem.text, 1)"></button>
                  </div>
                  <div class="text" v-html="getPopupTextElem(getDispChoiceText(choiceItem.confuserIndex ,choiceItem.confuserItemIndex, choiceItem.text))"
                       :class="getTextFontClassStile(getDispChoiceText(choiceItem.confuserIndex ,choiceItem.confuserItemIndex, choiceItem.text), productLanguage)" ></div>
                </div>
                <div v-show="showChoice2" class="item" v-bind:class="{disabled:choiceDisabled}" v-bind:id="'choice_list_2_' + index" v-for="(choiceItem2, index) in choiceList2" @click="clickAnswer(choiceItem2.text, (choiceList.length + index), 2)" :key="index"
                     @touchstart="onTouchStart(getDispChoiceText(choiceItem2.confuserIndex ,choiceItem2.confuserItemIndex, choiceItem2.text), 2, choiceItem2.sound)"
                     @touchend="onTouchEnd()"
                     @touchmove="onTouchEnd()"
                     @mousedown="$emit('hintMouseDown', $event)" @mouseup="$emit('hintMouseUp', $event)"
                     @mousemove="$emit('hintMouseMove', $event)">
                  <button v-show="showPinchInBtn" class="icon-pinch-in" @click="clickPinchIn(getDispChoiceText(choiceItem2.confuserIndex ,choiceItem2.confuserItemIndex, choiceItem2.text), 2, choiceItem2.sound)"></button>
                  <div class="buttons">
                    <button class="icon-num2"></button>
                    <button class="icon-voice disabled" @click="choiceAudioPlay(choiceItem2.text, 2)"></button>
                  </div>
                  <div class="text" v-html="getPopupTextElem(getDispChoiceText(choiceItem2.confuserIndex ,choiceItem2.confuserItemIndex, choiceItem2.text))"
                       :class="getTextFontClassStile(getDispChoiceText(choiceItem2.confuserIndex ,choiceItem2.confuserItemIndex, choiceItem2.text), productLanguage)" ></div>
                </div>
              </template>

              <!-- スマホレイアウト -->
              <template v-else>
                <div class="box-left-input">
                  <div v-show="showChoice" class="item" v-bind:id="'choice_list_1_' + index" v-for="(choiceItem, index) in choiceList" @click="clickAnswer(choiceItem.text, index, 1)" :key="index"
                       @touchstart="onTouchStart(getDispChoiceText(choiceItem.confuserIndex ,choiceItem.confuserItemIndex, choiceItem.text), 1, choiceItem.sound)"
                       @touchend="onTouchEnd()"
                       @touchmove="onTouchEnd()"
                       @mousedown="$emit('hintMouseDown', $event)" @mouseup="$emit('hintMouseUp', $event)"
                       @mousemove="$emit('hintMouseMove', $event)">
                    <button v-show="showPinchInBtn" class="icon-pinch-in" @click="clickPinchIn(getDispChoiceText(choiceItem.confuserIndex ,choiceItem.confuserItemIndex, choiceItem.text), 1, choiceItem.sound)"></button>
                    <div class="buttons">
                      <button class="icon-num1"></button>
                      <button class="icon-voice disabled" @click="choiceAudioPlay(choiceItem.text, 1)"></button>
                    </div>
                    <div class="text" v-html="getDispChoiceText(choiceItem.confuserIndex ,choiceItem.confuserItemIndex, choiceItem.text)" />
                  </div>
                </div>
                <div class="box-right-input">
                  <div v-show="showChoice2" class="item" v-bind:id="'choice_list_2_' + index" v-for="(choiceItem2, index) in choiceList2" @click="clickAnswer(choiceItem2.text, (choiceList.length + index), 2)" :key="index"
                       @touchstart="onTouchStart(getDispChoiceText(choiceItem2.confuserIndex ,choiceItem2.confuserItemIndex, choiceItem2.text), 2, choiceItem2.sound)"
                       @touchend="onTouchEnd()"
                       @touchmove="onTouchEnd()"
                       @mousedown="$emit('hintMouseDown', $event)" @mouseup="$emit('hintMouseUp', $event)"
                       @mousemove="$emit('hintMouseMove', $event)">
                    <button v-show="showPinchInBtn" class="icon-pinch-in" @click="clickPinchIn(getDispChoiceText(choiceItem2.confuserIndex ,choiceItem2.confuserItemIndex, choiceItem2.text), 2, choiceItem2.sound)"></button>
                    <div class="buttons">
                      <button class="icon-num2"></button>
                      <button class="icon-voice disabled" @click="choiceAudioPlay(choiceItem2.text, 2)"></button>
                    </div>
                    <div class="text" v-html="getDispChoiceText(choiceItem2.confuserIndex ,choiceItem2.confuserItemIndex, choiceItem2.text)" />
                  </div>
                </div>
              </template>
            </template>
            <template v-else>
              <template v-for="(choiceItem, index) in choiceList">
                <div v-show="showChoice" class="item" :key="index">
                  <div class="wraptext">
                    <button v-show="showPinchInBtn" class="icon-pinch-in" @click="clickPinchIn(getDispChoiceText(choiceItem.confuserIndex ,choiceItem.confuserItemIndex, choiceItem.text), 1, choiceItem.sound)"></button>
                    <div class="text" v-bind:id="'choice_list_' + index"
                         @click="clickAnswer(choiceItem.text, index, 1)" :class="isMobile() ? '' : getTextFontClassTile(getDispChoiceText(choiceItem.confuserIndex ,choiceItem.confuserItemIndex, choiceItem.text), productLanguage)"
                         @touchstart="onTouchStart(getDispChoiceText(choiceItem.confuserIndex ,choiceItem.confuserItemIndex, choiceItem.text), 1, choiceItem.sound)"
                         @touchend="onTouchEnd()"
                         @touchmove="onTouchEnd()"
                         @mousedown="$emit('hintMouseDown', $event)" @mouseup="$emit('hintMouseUp', $event)"
                         @mousemove="$emit('hintMouseMove', $event)">
                         <span v-html="getPopupTextElem(getDispChoiceText(choiceItem.confuserIndex ,choiceItem.confuserItemIndex, choiceItem.text))" ></span>
                    </div>
                  </div>
                  <button v-show="showQestionVoice && showChoice" class="icon-voice disabled" @click="choiceAudioPlay(choiceItem.text)"></button>
                </div>
              </template>

            </template>

          </div>
        </div>

        <CommonAct :pathstep="pathstep" :activeType="activeType" :actChoice="false" :horizontalRow="false" :actTextList="actTextList"
                   :isShowTextsParent="isShowTextsParent" :isShowVoicesParent="isShowVoicesParent" :isActivesParent="isActivesParent"
                   :isCorrectsParent="isCorrectsParent" :isInCorrectsParent="isInCorrectsParent" :isShowAnswerParent="isShowAnswerParent"
                   :changeActives="changeActives" :changeIsCorrects="changeIsCorrects" :changeIsInCorrects="changeIsInCorrects"
                   :changeIsShowAnswer="changeIsShowAnswer" :changeEndAct="changeEndAct" :changeActTextList="changeActTextList"
                   :scriptSystems="scriptSystems" :needsSwiper="true" :style="tileStyles" />
      </div>
    </div>
  </div>
</template>
<script>
import common from "@/mixin/common";
import runmode from "@/mixin/runmode";
import audio from "@/mixin/audio";
import layoutID from "@/mixin/layoutID";
import * as mixinConstants from "@/mixin/constants";
import * as constants from "@/store/constants";

// コンポーネント
import CommonAct from "./CommonAct";
import PinchInQue from "./PinchInQue";
import PinchInActStore from "./PinchInActStore";

export default {
  name: "Tile",
  props: {
    productLanguage: String,
    changeTileFlag: Boolean,
    scriptSystems: Object
  },
  mixins: [
    common,
    runmode,
    audio,
    layoutID
  ],
  data() {
    return {
      // 回答選択欄表示フラグ
      showSelectAnswer: false,
      // 現在出題中のACT
      currentData: null,
      // 適用するレイアウトクラス
      activeType: "active-type3",
      // 出題テキストの音声再生アイコンを表示するかを判断するフラグ
      showQestionVoice: false,
      // 各ACTのテキストを表示するかを判断するBoolean配列
      isShowTextsParent: [],
      // 各ACTの音声再生アイコンを表示するかを判断するBoolean配列
      isShowVoicesParent: [],
      // 各ACTに表示するテキストをまとめたobj配列
      actTextList: [],
      // 全問正解時のタイマー
      allCorrectTimer: null,
      // activeクラスを適用するかを判断するBoolean配列
      isActivesParent: [],
      // 監視用ステータス
      changeActives: false,
      // 選択肢をまとめたリスト
      choiceList: [],
      // 2つ目の選択肢をまとめたリスト(STile用）
      choiceList2: [],
      // 選択肢①の表示を判断するフラグ
      showChoice: false,
      // 選択肢②の表示を判断するフラグ
      showChoice2: false,
      // 正解／不正解を判断するフラグ（storeコミット用）
      ActState: true,
      // 正解かを判断するBoolean配列
      isCorrectsParent: [],
      // 監視用ステータス
      changeIsCorrects: false,
      // 不正解かを判断するBoolean配列
      isInCorrectsParent: [],
      // 監視用ステータス
      changeIsInCorrects: false,
      // 出題テキスト領域全体を表示するかを判断するフラグ
      isSelectAnswer: [],
      // 各ACTに正解テキストを表示するかを判断するBoolean配列
      isShowAnswerParent: [],
      // 監視用ステータス
      changeIsShowAnswer: false,
      // 監視用ステータス
      changeEndAct: false,
      // 空所の正解数
      choiceCorrectCount: 0,
      // 監視用ステータス
      changeActTextList: false,
      // ピンチインを表示するかを判断するフラグ
      isShowPinchIn: false,
      // ピンチイン時に表示するテキスト
      pinchInText: "",
      // ピンチイン時の表示内容を判断するフラグ（STileのみ表示内容異なるため）
      isStile: false,
      // ピンチイン時に表示する選択肢番号（STile用）
      choiceNum: 0,
      // clickAnswer()制御フラグ
      isPlayChoiceAudio: false,
      choiceTextList: [],
      tileTextList: [],
      // 回答済の選択肢
      correctActChoiceIndex: [],
      // ピンチインボタン表示フラグ
      showPinchInBtn: false,
      // ピンチイン対象の音声
      pinchInSound: "",
      // タッチイベント長押しタイマー
      touchTimer: null,
      // 選択肢活性状態管理フラグ
      choiceDisabled: false
    };
  },
  components: {
    CommonAct,
    PinchInQue,
    PinchInActStore
  },
  created() {
    this.$store.dispatch("initPinchInAct");
    this.init();
  },
  beforeDestroy: function() {
    for (var i = 0; i < this.pathstep.acts.length; i++) {
      this.pathstep.acts[i].correct = false;
    }
  },
  methods: {
    init: function() {
      const self = this;

      // 拡大表示ボタン表示フラグ
      this.showPinchInBtn = this.isShowPinchInBtn(this.productLanguage, this.displayMode);

      this.editActText();

      // 各Actのテキスト／音声再生アイコンを表示するかを判定する
      this.isShowQestionVoice();
      this.initShowActText();
      this.initShowActVoice();
      this.initShowAnswerText();
    },
    /**
     * ACTのテキスト表示を編集する
     */
    editActText: function() {
      this.log("Tile start editActText");

      this.actTextList = [];

      for (var i = 0; i < this.pathstep.acts.length; i++) {
        var answerText = this.getAnswerTextAct(i);
        var questionText = this.getQuestionText(i);
        var obj = { answerText: answerText, questionText: questionText };
        this.actTextList[i] = obj;
      }
    },
    /**
     * ACTのテキスト（全文）を取得する。
     */
    getAnswerTextAct: function(index) {
      this.log("Tile start getAnswerText");

      // 言語に応じたテキスト取得
      return this.getLanguageBasicText(this.pathstep.acts[index].texts, this.productLanguage, this.scriptType, this.displayMode, this.scriptSystems.default);
    },
    /**
     * ACTのテキストを取得する。
     * challengeの場合は空所ありの状態で返却する。
     */
    getQuestionText: function(index) {
      this.log("Tile start getQuestionText");

      var questionText = "";
      var choiceCount = 0;

      if (this.changeTileFlag) {
        if (this.pathstep.acts[index].texts[0].tileText == "") {
          return this.getAnswerTextAct(index);
        }
      }

      if (this.isChallenge(this.pathstep.acts[index])) {
        // スクリプトIDでtext要素取得
        var obj = this.getTextObjByScriptID(this.pathstep.acts[index].texts, this.productLanguage, this.scriptType, this.displayMode, this.scriptSystems.default);
        var textObj = obj.textObj;

        var textList = this.getDividedTexts(textObj.tileText);

        var setInput1 = false;
        for (var i = 0; i < textList.length; i++) {
          if (this.isChoiceText(textList[i])) {
            choiceCount += 1;
            if (this.pathstep.mode === mixinConstants.RUNMODE_STILE) {
              if (setInput1) {
                questionText += '<span class="input input2" id="act' + index + "_blank" + 2 + '"></span>';
              } else {
                questionText += '<span class="input input1" id="act' + index + "_blank" + 1 + '"></span>';
                setInput1 = true;
              }
            } else {
              questionText += '<span class="input" id="act' + index + "_blank" + choiceCount + '"></span>';
            }
          } else {
            questionText += textList[i];
          }
        }
        if (obj.pinyin) {
          // ピンイン付き表示
          questionText = this.getChineseTextWithPinyin(questionText, obj.pinyin.tileText.replace(/\[([^\]]*)\]/g, "").replace(/ +/g, " ").trim());
        }
        if (obj.kana) {
          // ふりがな表示
          questionText = this.getJapaneseTextWithKana(questionText, textObj.superScripts, textObj.confusers);
        }
        // 正解済の場合
        if (this.correctActChoiceIndex[index]) {
          // テキスト入力欄で分割
          var textList = this.devideTextSpan(questionText);
          // 入力欄Hit回数
          var hitCount = 0;
          // 選択肢文字列一覧取得
          var choiceTextList = this.setDispChoiceTextList(this.pathstep.acts[index]);
          // 一時テキスト
          var tmpText = "";
          for (var i = 0; i < textList.length; i++) {
            if (textList[i].slice(0, 5) === "<span") {
              // 入力欄にヒット
              // 選択肢の番号
              var confuserIndex = false;
              if (this.pathstep.mode === mixinConstants.RUNMODE_STILE) {
                // STILE
                if (hitCount == 0 && this.correctActChoiceIndex[index][1]) {
                  // 最初の選択肢
                  confuserIndex = 0;
                } else if (hitCount == 1 && this.correctActChoiceIndex[index][2]) {
                  // 2番目の選択肢
                  confuserIndex = 1;
                }
              } else {
                // STILE以外
                if (this.correctActChoiceIndex[index][hitCount]) {
                  confuserIndex = hitCount;
                }
              }
              if (confuserIndex !== false && choiceTextList.answers[confuserIndex]) {
                // 回答文に置き換え
                tmpText += choiceTextList.answers[confuserIndex];
              } else {
                tmpText += textList[i];
              }
              hitCount++;
            } else {
              // 入力エリア以外
              tmpText += textList[i];
            }
          }
          questionText = tmpText;
        }
      } else {
        questionText = this.getAnswerTextAct(index);
      }
      return questionText;
    },
    /**
     * 選択肢のリストを取得する
     */
    getChoiceList: function(index) {
      this.log("Tile start getChoiceList");

      var choiceList = [];
      var confusers = this.pathstep.acts[this.currentData.index].texts[0].confusers[index];

      for (var i = 0; i < confusers.length; i++) {
        choiceList.push({
          text: confusers[i].text,
          confuserIndex: index,
          confuserItemIndex: i,
          sound: confusers[i].sound
        });
      }

      return _.shuffle(choiceList);
    },
    /**
     * テキストを<span>タグ毎に分ける
     */
    devideTextSpan: function(text) {
      this.log("Tile start devideTextSpan");

      return text.replace(/<span/g, "####<span").replace(/<\/span>/g, "</span>####").split("####");
    },
    /**
     * 対象のテキストの[]を削除する
     */
    deleteBracket: function(text) {
      return text.replace(/\[|\]/g, "").split("/");
    },
    /**
     * 問題出題処理
     */
    question: function() {
      this.log("Tile start question");

      const self = this;

      this.choiceCorrectCount = 0;
      this.changeActTextList = false;
      this.currentData = this.getQuestion();

      // スコア表示中・全解答表示中は問題出題しない
      if (this.lessonState === constants.LESSON_STATE_PAUSE || this.dispAllAnswerStatus) {
        return;
      }

      // 問題取得できない場合は、次のpathstepへ遷移する
      if (this.currentData === null) {
        this.changeEndAct = true;

        // 親(Runmode.Vue）に通知する
        this.allCorrectTimer = setTimeout(function() {
          self.$emit("endAct");
        }, mixinConstants.ALLCORRECT_INTERVAL);
        return;
      }

      this.isActivesParent = [];
      this.isActivesParent[this.currentData.index] = true;
      this.changeActives = true;

      this.sliderToActiveAct(this.currentData.index).then(function() {
        if (self.changeTileFlag) {
          if (self.isChallenge(self.currentData.act) && self.currentData.act.texts[0].tileText != "") {
            self.commonChallengeQuestion();
          } else {
            self.commonGivenQuestion();
          }
        } else {
          if (self.isChallenge(self.currentData.act)) {
            self.commonChallengeQuestion();
          } else {
            self.commonGivenQuestion();
          }
        }
      });
    },
    /**
     * challenge出題共通処理
     */
    commonChallengeQuestion: function() {
      // 問題文表示文言一覧セット
      this.choiceTextList = this.setDispChoiceTextList(this.currentData.act).texts;

      this.choiceQuestion();
    },
    /**
     * given出題共通処理
     */
    commonGivenQuestion: function() {
      const self = this;
      this.audioPlay(this.currentData.act.sounds[0]);
      this.changeActives = false;
      this.pathstep.acts[this.currentData.index].correct = true;

      // usageが1だが選択肢がない場合、スコアを保存(P系から切り替わった場合のみ)
      if (this.changeTileFlag) {
        if (this.isChallenge(this.currentData.act) && this.currentData.act.texts[0].tileText == "") {
          this.setActState(true);
        }
      }

      var endedEvent = function() {
        $(self.myAudio).off("ended error", endedEvent);
        self.setInterval(mixinConstants.QUESTION_INTERVAL).then(function() {
          self.question();
        });
      };
      $(self.myAudio).on("ended error", endedEvent);
    },
    /**
     * 選択肢を出題する
     */
    choiceQuestion: function() {
      this.log("Tile start choiceQuestion");

      const self = this;

      this.showSelectAnswer = true;

      var textList = this.getDividedTexts(this.currentData.act.texts[0].tileText);
      var choiceCount = 0;

      if (this.pathstep.mode !== mixinConstants.RUNMODE_LTILE) {
        // P系から切り替わった場合は、マスク音のみ再生する
        if (self.changeTileFlag) {
          self.audioMask();
        }

        var promise = new Promise(function(res, rej) {
          function loop(i) {
            return new Promise(function(resolve, reject) {
              var promiseAudio = {};

              if (!self.changeTileFlag) {
                self.audioPlay(self.currentData.act.sounds[i]);
              }

              if (self.isChoiceText(textList[i])) {
                choiceCount += 1;
                if (choiceCount === 1) {
                  self.showChoice = true;
                  self.choiceList = self.getChoiceList(choiceCount - 1);
                  self.changeClassInput(choiceCount);
                } else {
                  if (self.pathstep.mode === mixinConstants.RUNMODE_STILE) {
                    if (!self.showChoice2) {
                      self.showChoice2 = true;
                      self.choiceList2 = self.getChoiceList(choiceCount - 1);
                      self.changeClassInput(choiceCount);
                    }
                  }
                }
              }
              var endedEvent = function() {
                $(self.myAudio).off("ended error", endedEvent);
                resolve(i + 1);
              };
              $(self.myAudio).on("ended error", endedEvent);
            }).then(function(count) {
              if (count > textList.length - 1) {
                res();
              } else {
                loop(count);
              }
            });
          }
          loop(0);
        });

        promise.then(function() {
          self.enabledIconVoice();
        });
      } else {
        // LetterTileの場合にIEとEdgeで動作しない問題に対応するため
        // 独自にAudioオブジェクトを生成して音声再生する
        var lTileAudio = new Audio();

        this.disabledIconVoice();
        this.isAudioPlaying = true;
        lTileAudio.src = this.currentData.act.sounds[this.currentData.act.sounds.length - 1];
        lTileAudio.load();
        lTileAudio.play();
        var endedEventParent = function(event) {
          $(lTileAudio).off("ended error", endedEventParent);
          var errorCode = "";
          try {
            errorCode = event.currentTarget.error.code;
          } catch (e) {
            errorCode = "none";
          }
          self.log("Tile end lTileAudioPlayParent errorCode: " + errorCode);
          self.enabledIconVoice();
          self.showChoice = true;
          self.choiceList = self.getChoiceList(self.choiceCorrectCount);
          self.changeClassInput(self.choiceCorrectCount + 1);
          lTileAudio.src = mixinConstants.AUDIO_MASK;
          lTileAudio.load();
          lTileAudio.play();

          var endedEventChild = function(event) {
            $(lTileAudio).off("ended error", endedEventChild);
            var errorCode = "";
            try {
              errorCode = event.currentTarget.error.code;
            } catch (e) {
              errorCode = "none";
            }
            self.log("Tile end lTileAudioPlayChild errorCode: " + errorCode);
            self.isAudioPlaying = false;
          };
          $(lTileAudio).on("ended error", endedEventChild);
        };
        $(lTileAudio).on("ended error", endedEventParent);
      }
    },
    /**
     * inputクラスをinput-activeクラスに変更する
     */
    changeClassInput: function(index) {
      this.log("Tile start changeClassInput");

      if (this.pathstep.mode === mixinConstants.RUNMODE_STILE) {
        return;
      }

      var targetID = "act" + this.currentData.index + "_blank" + index;
      var targetElement = document.getElementById(targetID);
      if (targetElement !== null) {
        targetElement.classList.remove("input");
        targetElement.classList.add("input-active");
      }
    },
    /**
     * 選択肢の押下処理
     */
    clickAnswer: function(text, index, choiceNum) {
      this.log("Tile start clickAnswer");

      const self = this;

      // ピンチイン表示時、音声再生中、選択肢非活性の場合は後続処理を実行しない
      if (this.isShowPinchIn || this.isPlayChoiceAudio || this.choiceDisabled) {
        return;
      }

      if (this.isSelectAnswer[index]) {
        return;
      }

      this.isSelectAnswer = [];
      this.isSelectAnswer[index] = true;

      for (var Child of this.$children) {
        Child.audioPause();
      }

      var correctText = this.getCorrectText(choiceNum);

      // 学習済登録
      this.$emit("updateLearnedGroup");

      this.sliderToActiveAct(this.currentData.index).then(function() {
        if (correctText === text) {
          // 正解の場合
          if (choiceNum === 1) {
            self.showChoice = false;
          } else {
            self.showChoice2 = false;
          }
          self.correctAnswer(text, index, choiceNum);
        } else {
          // 選択肢を非活性にする
          self.choiceDisabled = true;
          // 不正解の場合
          self.inCorrectAnswer(index);
        }
      });
    },
    /**
     * 正解のテキストを取得する
     */
    getCorrectText: function(choiceNum) {
      this.log("Tile start getCorrectText");

      var correctText = "";
      var confusers = null;

      if (this.pathstep.mode === mixinConstants.RUNMODE_STILE) {
        confusers = this.pathstep.acts[this.currentData.index].texts[0].confusers[choiceNum - 1];
      } else {
        confusers = this.pathstep.acts[this.currentData.index].texts[0].confusers[this.choiceCorrectCount];
      }

      for (var i = 0; i < confusers.length; i++) {
        if (confusers[i].correct) {
          return confusers[i].text;
        }
      }
      return correctText;
    },
    /**
     * 正解時の処理
     */
    correctAnswer: function(text, index, choiceNum) {
      this.log("Tile start correctAnswer");

      this.isSelectAnswer[index] = false;
      const self = this;

      if (!this.correctActChoiceIndex[this.currentData.index]) {
        this.correctActChoiceIndex[this.currentData.index] = [];
      }
      if (this.pathstep.mode === mixinConstants.RUNMODE_STILE) {
        this.correctActChoiceIndex[this.currentData.index][choiceNum] = true;
      } else {
        this.correctActChoiceIndex[this.currentData.index][this.choiceCorrectCount] = true;
      }

      this.choiceCorrectCount += 1;

      if (this.choiceCorrectCount === this.getBlankCount()) {
        this.disabledIconVoice();

        this.isShowAnswerParent[this.currentData.index] = true;
        this.changeIsShowAnswer = true;

        // スコアを登録する
        this.setActState(this.ActState);
        this.ActState = true;

        // 正解音の再生
        this.audioCorrect();

        // 正解画像の表示
        this.isCorrectsParent = [];
        this.isInCorrectsParent = [];
        this.isCorrectsParent[this.currentData.index] = true;
        this.changeIsCorrects = true;

        this.pathstep.acts[this.currentData.index].correct = true;

        this.setInterval(mixinConstants.INCORRECT_INTERVAL).then(function() {
          // 正解画像を非表示に変更する
          self.changeIsCorrects = false;

          if (self.lessonState === constants.LESSON_STATE_PAUSE) {
            self.enabledIconVoice();
            self.changeActives = false;
            self.changeIsShowAnswer = false;
            return;
          }

          self.audioPlay(self.currentData.act.sounds[self.currentData.act.sounds.length - 1]);
          var endedEvent = function() {
            $(self.myAudio).off("ended error", endedEvent);
            self.changeActives = false;
            self.changeIsShowAnswer = false;

            self.setInterval(mixinConstants.QUESTION_INTERVAL).then(function() {
              // 次の問題出題
              self.question();
            });
          };
          $(self.myAudio).on("ended error", endedEvent);
        });
      } else {
        // 次の空所を出題
        this.nextChoice(text, index, choiceNum);
      }
    },
    /**
     * 不正解時の処理
     */
    inCorrectAnswer: function(index) {
      this.log("Tile start inCorrectAnswer");

      const self = this;

      this.ActState = false;
      this.disabledIconVoice();

      // 不正解音声再生
      this.audioInCorrect();

      // 不正解画像の表示
      this.isCorrectsParent = [];
      this.isInCorrectsParent = [];
      this.isInCorrectsParent[this.currentData.index] = true;
      this.changeIsInCorrects = true;

      this.setInterval(mixinConstants.INCORRECT_INTERVAL).then(function() {
        // 不正解画像を非表示に変更する
        self.enabledIconVoice();
        self.changeIsInCorrects = false;
        self.isSelectAnswer[index] = false;

        // 選択肢を活性にする
        self.choiceDisabled = false;

        // 2番目の空所が表示されない場合は表示する
        if (self.pathstep.mode === mixinConstants.RUNMODE_STILE) {
          if ((self.choiceCorrectCount < 1 && !self.showChoice2) || (!self.showChoice && !self.showChoice2)) {
            self.choiceList2 = self.getChoiceList(1);
            self.showChoice2 = true;
            setTimeout(function() {
              self.enabledIconVoice();
            }, 100);
          }
        }
      });
    },
    /**
     * 対象のACTの空所の数を取得する
     */
    getBlankCount: function() {
      this.log("Tile start blankCount");

      var blankCount = 0;

      var textList = this.getDividedTexts(this.currentData.act.texts[0].tileText);
      for (var i = 0; i < textList.length; i++) {
        if (this.isChoiceText(textList[i])) {
          blankCount += 1;
        }
      }
      return blankCount;
    },
    /**
     * 次の空所を出題する
     */
    nextChoice: function(text, index, choiceNum) {
      this.log("Tile start nextChoice");

      const self = this;

      var textList = this.devideTextSpan(this.actTextList[this.currentData.index].questionText);
      var questionText = "";
      var isSetBlankText = false;

      if (choiceNum == 2) {
        var index2 = index - this.choiceList.length;
        var dispText = this.getDispChoiceText(this.choiceList2[index2].confuserIndex, this.choiceList2[index2].confuserItemIndex, text);
      } else {
        var dispText = this.getDispChoiceText(this.choiceList[index].confuserIndex, this.choiceList[index].confuserItemIndex, text);
      }

      // 正解した空所のテキストを表示する
      for (var i = 0; i < textList.length; i++) {
        if (textList[i].slice(0, 5) === "<span") {
          if (this.pathstep.mode === mixinConstants.RUNMODE_STILE) {
            if (choiceNum === 1) {
              if (isSetBlankText) {
                questionText += textList[i];
              } else {
                questionText += dispText;
                isSetBlankText = true;
              }
            } else {
              if (!isSetBlankText) {
                questionText += textList[i];
                isSetBlankText = true;
              } else {
                questionText += dispText;
              }
            }
          } else {
            if (isSetBlankText) {
              questionText += textList[i];
            } else {
              questionText += dispText;
              isSetBlankText = true;
            }
          }
        } else {
          questionText += textList[i];
        }
      }

      this.actTextList[this.currentData.index].questionText = questionText;
      this.changeActTextList = true;

      // 次の空所を出題する
      if (this.pathstep.mode !== mixinConstants.RUNMODE_STILE) {
        this.setInterval(1).then(function() {
          self.choiceList = self.getChoiceList(self.choiceCorrectCount);
          self.changeClassInput(self.choiceCorrectCount + 1);
          self.showChoice = true;
          self.changeActTextList = false;
        });
      }
    },
    /**
     * リスタート時の処理
     */
    reStart: function() {
      this.log("Tile start reStart");

      if (this.choiceCorrectCount === 0) {
        if (!this.showChoice && !this.showChoice2) {
          this.question();
        } else {
          // 2番目の空所が表示されない場合は表示する
          if (this.pathstep.mode === mixinConstants.RUNMODE_STILE) {
            if (this.choiceCorrectCount < 1 && !this.showChoice2) {
              this.choiceList2 = this.getChoiceList(1);
              this.showChoice2 = true;
            }
          }
          this.enabledIconVoice();
        }
      } else {
        if (this.choiceCorrectCount === this.getBlankCount()) {
          this.question();
        }
      }
    },
    /**
     * 全解答表示時の処理
     */
    showAllAnswer: function() {
      this.log("Tile start showAllAnswer");

      this.showSelectAnswer = false;
    },
    /**
     * 全解答解除時の処理
     */
    hideAllAnswer: function() {
      this.log("Tile start hideAllAnswer");

      this.showSelectAnswer = true;
    },
    /**
     * 出題用の音声再生アイコンを表示するかを判定する
     */
    isShowQestionVoice: function() {
      this.log("Tile start isShowQestionVoice");

      switch (this.pathstep.mode) {
        case mixinConstants.RUNMODE_TILE:
        case mixinConstants.RUNMODE_STILE:
          this.showQestionVoice = true;
          break;
        case mixinConstants.RUNMODE_LTILE:
          this.showQestionVoice = false;
          break;
        default:
          break;
      }
    },
    /**
     * 初期表示時に各Actのテキストを表示するかを判定する
     */
    initShowActText: function() {
      this.log("Tile start initShowActText");

      for (var i = 0; i < this.pathstep.acts.length; i++) {
        this.isShowTextsParent[i] = true;
      }
    },
    /**
     * 初期表示時に各Actの音声再生アイコンを表示するかを判定する
     */
    initShowActVoice: function() {
      this.log("Tile start initShowActVoice");

      for (var i = 0; i < this.pathstep.acts.length; i++) {
        if (this.changeTileFlag) {
          // 選択肢がある場合
          if (this.pathstep.acts[i].texts[0].confusers.length != 0) {
            this.isShowVoicesParent[i] = false;
            continue;
          }
        }

        this.isShowVoicesParent[i] = true;
      }
    },
    /**
     * 初期表示時に各Actの正解を表示するかを判定する
     */
    initShowAnswerText: function() {
      this.log("Tile start initShowAnswerText");

      for (var i = 0; i < this.pathstep.acts.length; i++) {
        if (this.isChallenge(this.pathstep.acts[i])) {
          this.isShowAnswerParent[i] = false;
        } else {
          this.isShowAnswerParent[i] = true;
        }
      }
    },
    /**
     * 選択肢の音声再生ボタン押下時の処理
     */
    choiceAudioPlay: function(text) {
      this.log("Tile start choiceAudioPlay");

      const self = this;
      this.isPlayChoiceAudio = true;

      var confusers = this.pathstep.acts[this.currentData.index].texts[0].confusers;
      for (var i = 0; i < confusers.length; i++) {
        for (var j = 0; j < confusers[i].length; j++) {
          if (confusers[i][j].text === text) {
            this.audioPlay(confusers[i][j].sound);
            break;
          }
        }
      }

      var endedEvent = function() {
        $(self.myAudio).off("ended error", endedEvent);
        self.isPlayChoiceAudio = false;
        self.enabledIconVoice();
      };
      $(self.myAudio).on("ended error", endedEvent);
    },
    /**
     * ピンチインボタン押下時の処理
     */
    clickPinchIn: function(text, choiceNum, sound) {
      this.log("Tile start clickPinchIn");

      this.isShowPinchIn = true;
      this.pinchInText = text;
      this.pinchInSound = sound;

      if (this.pathstep.mode === mixinConstants.RUNMODE_STILE) {
        this.isStile = true;
        this.choiceNum = choiceNum;
      }

      this.log("Tile clickPinchIn: set lessonState: " + constants.LESSON_STATE_PAUSE);
      this.$store.dispatch("setLessonState", constants.LESSON_STATE_PAUSE);
    },
    /**
     * ピンチアウト押下通知を受け取る
     */
    recievePinchOut: function() {
      this.log("Tile start recievePinchOut");

      if (this.$store.getters.lessonState === constants.LESSON_STATE_PAUSE) {
        // state更新して、レッスンを再開
        this.log("Tile recievePinchOut: set lessonState: " + constants.LESSON_STATE_RESTART);
        this.$store.dispatch("setLessonState", constants.LESSON_STATE_RESTART);
      }
    },
    /**
     * 選択肢表示テキスト取得
     */
    setDispChoiceTextList: function(act) {
      // 引数のactが存在しない場合は処理終了
      if (!act) {
        return;
      }

      // JSONconfuserリスト
      var confuserList = [];
      var obj = this.getTextObjByScriptID(act.texts, this.productLanguage, this.scriptType, this.displayMode, this.scriptSystems.default);
      // 問題文リスト
      var confuserList = obj.textObj.confusers;
      // ピンイン問題文
      var pinyin = null;
      if (obj.pinyin) {
        pinyin = obj.pinyin.confusers;
      }
      // 文字列
      var result = [];
      // 正解
      var answers = [];
      // 表示用文字列配列生成
      for (let i = 0; i < confuserList.length; i++) {
        var tmp = [];
        for (let j = 0; j < confuserList[i].length; j++) {
          var text = confuserList[i][j].text.replace(/(,|\.|\?)/g, "");
          if (pinyin && pinyin[i][j]) {
            // ピンイン表示
            text = this.getChineseTextWithPinyin(text, pinyin[i][j].text);
          }
          if (obj.kana) {
            // ふりがな表示
            text = this.getJapaneseTextWithKana(text, confuserList[i][j].superScripts);
          }
          tmp[j] = text;
          if (confuserList[i][j].correct) {
            answers[i] = text;
          }
        }
        result[i] = tmp;
      }
      return {
        texts: result,
        answers: answers
      };
    },
    /**
     * 表示用文字を取得
     * @param int confuserIndex  JSON confuserのindex
     * @param int confuserItemIndex JSON confuserの子要素のindex
     * @param string defaultText 取得できない場合のデフォルト文字列
     * @returns {default.methods@arr;@arr;choiceTextList}
     */
    getDispChoiceText: function(confuserIndex, confuserItemIndex, defaultText) {
      if (this.choiceTextList[confuserIndex] && this.choiceTextList[confuserIndex][confuserItemIndex]) {
        return this.choiceTextList[confuserIndex][confuserItemIndex];
      } else {
        return defaultText;
      }
    },
    /**
     * 長押しイベント開始
     * @param String text 表示テキスト
     * @param Int choiceNum 選択肢番号
     * @param String sound 音声ファイル
     * @returns {undefined}
     */
    onTouchStart: function(text, choiceNum, sound) {
      var self = this;
      this.touchTimer = setTimeout(function() {
        self.clickPinchIn(text, choiceNum, sound);
      }, mixinConstants.LONGTOUCH_DURATION);
    },
    /**
     * 長押しイベント終了
     */
    onTouchEnd: function() {
      clearTimeout(this.touchTimer);
    },
    /**
     * カード領域自動サイズ調整処理
     */
    autoAdjustCardArea: function() {

      // PC版の場合は処理終了
      if (this.isEnvironmentPc()) {
        return;
      }

      let clones = {};
      const cloneCard = function(targetText) {
        // カードを複製
        clones.card = $(".card-inner:first > .swiper-container:first > .swiper-wrapper:first > .item:first").clone();
        clones.textArea = clones.card.children("div").children(".select");
        clones.text = clones.textArea.children("span");
        // 複製した要素にテキストを設定してDOMに追加
        clones.text.html(targetText);
        clones.card.appendTo(".card-inner:first > .swiper-container:first > .swiper-wrapper:first");
      };

      // 対象となるテキストを取得する
      let targetTexts = this.getAllBasicTexts(this.pathstep.acts, this.productLanguage, this.scriptType, this.scriptSystems.default, false);
      let tileTexts = this.getTileTexts(this.productLanguage, this.scriptSystems.default);
      const push = Array.prototype.push;
      for (let displayMode in targetTexts) {
        push.apply(targetTexts[displayMode], tileTexts[displayMode]);
      }

      // サイズを確定させる
      this.fixCardAreaSize(targetTexts, cloneCard, clones);
    },
    /**
     * カード領域サイズ適用
     */
    applyCardAreaSize: function() {
      // PC版の場合は処理終了
      if (this.isEnvironmentPc()) {
        return;
      }
      // 適用サイズ取得
      let fixedHeight = this.cardAreaHeight[this.displayMode];
      let fixedFontSize = this.cardAreaFontSize[this.displayMode];
      // 確定した高さとフォントサイズを設定
      let textArea = $(".card-inner > .swiper-container > .swiper-wrapper > .item > div > .select");
      textArea.height(fixedHeight);
      textArea.css({ fontSize: fixedFontSize });
      this.tileSize = fixedFontSize;
      let cardHeight = this.getComputedStyleHeight(".card-inner > div:first");
      $(".cards-container").height(cardHeight);
      // 出題文表示領域の高さを調整する
      let rootHeight = this.getComputedStyleHeight(".root");
      let headerHeight = this.getComputedStyleHeight(".header");
      let footerHeight = this.getComputedStyleHeight(".sp-second-header");
      let cardsContainerHeight = this.getComputedStyleHeight(".cards-container");
      $(".toparea-play").height(rootHeight - headerHeight - footerHeight - cardsContainerHeight);
    }
  },
  watch: {
    /**
     * ツールバー「全解答を表示する」の選択状態を監視する
     */
    dispAllAnswerStatus: function(newstatus) {
      this.log("Tile watch dispAllAnswerStatus");

      if (this.dispAllAnswerStatus) {
        this.showAllAnswer();
        if (this.allCorrectTimer !== null) {
          clearTimeout(this.allCorrectTimer);
        }
      } else {
        this.hideAllAnswer();
        this.reStart();
      }
    },
    /**
     * スコア表示状態を監視する
     */
    lessonState: function(newstatus) {
      this.log("Tile watch lessonState");

      if (this.lessonState === constants.LESSON_STATE_START) {
        // 問題文の取得
        this.question();
      } else if (this.lessonState === constants.LESSON_STATE_STOP) {
        this.$emit("stopAct");
      } else if (this.lessonState === constants.LESSON_STATE_PAUSE) {
        this.changeActives = false;
        if (this.allCorrectTimer !== null) {
          clearTimeout(this.allCorrectTimer);
        }
      } else if (this.lessonState === constants.LESSON_STATE_RESTART) {
        // P系RunmodeからTile系Runmodeに切り替えている場合かつ、音声認識が有効の場合は、再出題しない（左記条件の場合は、P系Runmodeに切り替わるため）
        if (this.sreUse === "true" && this.changeTileFlag) {
          return;
        }
        if (this.isShowPinchIn) {
          this.isShowPinchIn = false;
          return;
        }
        if (!this.dispAllAnswerStatus) {
          this.reStart();
        }
      }
      // 表示領域自動調整
      let funcs = [this.autoAdjustCardArea, this.applyCardAreaSize];
      this.autoAdjustFirstShown(funcs, [".page-content"]);
    },
    scriptType: function(newstatus) {
      // 問題テキスト切り替え
      if (this.currentData) {
        this.choiceTextList = this.setDispChoiceTextList(this.currentData.act).texts;
      }
      // ACTテキスト切り替え
      this.editActText();
      // 拡大表示ボタン表示フラグ
      this.showPinchInBtn = this.isShowPinchInBtn(this.productLanguage, this.displayMode);
      // 自動調整サイズ適用
      this.applyCardAreaSize();
    },
    /**
     * 表示切り替え
     *
     * @param {String} newstatus
     */
    displayMode: function(newstatus) {
      // 問題テキスト切り替え
      if (this.currentData) {
        this.choiceTextList = this.setDispChoiceTextList(this.currentData.act).texts;
      }
      // ACTテキスト切り替え
      this.editActText();
      // 拡大表示ボタン表示フラグ
      this.showPinchInBtn = this.isShowPinchInBtn(this.productLanguage, this.displayMode);
      // 自動調整サイズ適用
      this.applyCardAreaSize();
    },
    /**
     * 音声認識の有効状態を監視する
     */
    sreUse: function(newstatus) {
      // 音声認識を有効に変更した場合
      if (newstatus === "true") {
        // P系RunmodeからTile系Runmodeに切り替えている場合は、P系Runmodeに切り替える
        if (this.changeTileFlag) {
          this.$parent.changeTileFlag = false;
          this.$parent.doStartLesson();
        }
      }
    }
  },
  mounted() {
    // 右から出題するレイアウト変換処理
    this.changeRtlLayout();

    if (this.isMobile()) {
      // スマホの場合は、sliderを初期化
      this.sliderInit();
      // 自動調整初期処理
      this.initAutoAdjust([".page-content"], [".page-content"]);
    }

    if (this.lessonState === constants.LESSON_STATE_START) {
      this.question();
    }
  }
};
</script>
<style scoped lang="scss">
@import "src/assets/style/card";
.toparea-text {
  .item {
    &.active {
      border: solid 2px #81af4a;
    }
  }
}
</style>
<style lang="scss">
.tile {
  @for $i from 1 through 10 {
    .font#{$i} {
      .input,
      .input-active {
        height: 10px;
        width: 15px;
      }
    }
  }
  @for $i from 10 through 140 {
    .font#{$i} {
      .input,
      .input-active {
        height: 1px * $i;
        @if $i <= 14 {
          width: 15px;
        } @else if $i <= 17 {
          width: 20px;
        } @else if $i <= 20 {
          width: 30px;
        } @else {
          width: 40px;
        }
      }
    }
  }
}
.stile {
  @for $i from 1 through 10 {
    .font#{$i} {
      .input1,
      .input2 {
        height: 10px;
        &:after {
          width: 8px;
          height: 8px;
          top: 1px;
          left: 12px;
        }
      }
    }
  }
  @for $i from 10 through 140 {
    .font#{$i} {
      .input1,
      .input2 {
        height: 1px * $i;
        &:after {
          width: 1px * $i - 4px;
          height: 1px * $i - 4px;
        }
      }
    }
  }
}
.stile {
  .input1 {
    border: solid 1px $dgray;
    background: $lgray3;
    width: 35px;
    position: relative;
    display: inline-block;
    margin: 0 5px;
    vertical-align: middle;
    &:after {
      content: "";
      display: block;
      margin: 0 auto;
      background-image: url(#{$imgpath}icon/png/num1.png);
      background-size: contain;
      background-repeat: no-repeat;
      position: relative;
      top: 1px;
    }
  }
  .input2 {
    border: solid 1px $mgray2;
    background: $lgray;
    width: 35px;
    position: relative;
    display: inline-block;
    margin: 0 5px;
    vertical-align: middle;
    &:after {
      content: "";
      display: block;
      margin: 0 auto;
      background-image: url(#{$imgpath}icon/png/num2.png);
      background-size: contain;
      background-repeat: no-repeat;
      position: relative;
      top: 1px;
    }
  }
}
.tile {
  .input-char {
    display: inline-block;
    border: solid 1px $input-bdcolor;
    background: $lgray;
    padding: 0 0;
    width: 18px;
    margin-right: 0px;
    height: 24px;
  }
  .input-char-active {
    display: inline-block;
    border: solid 1px $input-bdcolor;
    background: #c0c0c0;
    padding: 0 0;
    width: 20px;
    margin-right: 0px;
    height: 26px;
    left: -1px;
    top: 2px;
  }
  .w50 {
    text-align: center;
    width: 50px;
  }
}
.tile {
  .page-content,
  .pinch-in-card {
    .input {
      display: inline-block;
      border: solid 1px $input-bdcolor;
      background: $lgray;
      margin-right: 3px;
      margin-left: 3px;
      + .input,
      + .input-active {
        margin-left: 0;
      }
    }
    .input-active {
      display: inline-block;
      border: solid 1px $input-bdcolor;
      background: #c0c0c0;
      margin-right: 3px;
      margin-left: 3px;
      + .input {
        margin-left: 0;
      }
    }
  }
}
.propSp {
  .tile,
  .stile {
    .input,
    .input-active {
      height: var(--tileHeight);
      width: var(--tileWidth);
    }
    .input1,
    .input2 {
      height: var(--tileHeight);
      &:after {
        height: var(--tileNumberSize);
        width: var(--tileNumberSize);
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// Tile.vue?7c5c7c9a